// extracted by mini-css-extract-plugin
export var externalLink = "_bo-0";
export var internalLinkLabel = "_bo-1";